import { makeCloudFunction } from "../makeCloudFunction";
import { User } from "@functions-types";
import { makeUseCloudFunction } from "../makeUseCloudFunction";

export type { User };
export const listUsers = makeCloudFunction<void, User[]>("user", "listUsers");
export const useListUsers = makeUseCloudFunction(listUsers);
